import APIClient from '@/shared/http/clients/api'

const resourceName = 'giro-carteira'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=name,asc&size=500`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetAllHistoryByFuncionarioId = (funcionarioId, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/historico/?funcionarioId=${funcionarioId}&page=${index}&size=${limit}&sort=dataAlteracao,desc`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)

const GiroCarteiraRepository = {
  GetAll,
  GetAllPaging,
  GetAllHistoryByFuncionarioId,
  GetById,
  Create,
  Delete
}

export default GiroCarteiraRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/girocarteira.js